/* tslint:disable */
/* eslint-disable */
/**
 * MTX Brokerage API
 * Brokerage agent-facing API for dispositions, listings, and transactions
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AccessIssues } from './AccessIssues';
import {
    AccessIssuesFromJSON,
    AccessIssuesFromJSONTyped,
    AccessIssuesToJSON,
} from './AccessIssues';
import type { AgentJustification } from './AgentJustification';
import {
    AgentJustificationFromJSON,
    AgentJustificationFromJSONTyped,
    AgentJustificationToJSON,
} from './AgentJustification';
import type { AllUtilitiesFunctional } from './AllUtilitiesFunctional';
import {
    AllUtilitiesFunctionalFromJSON,
    AllUtilitiesFunctionalFromJSONTyped,
    AllUtilitiesFunctionalToJSON,
} from './AllUtilitiesFunctional';
import type { AnyHomeDamage } from './AnyHomeDamage';
import {
    AnyHomeDamageFromJSON,
    AnyHomeDamageFromJSONTyped,
    AnyHomeDamageToJSON,
} from './AnyHomeDamage';
import type { AppliancesFinish } from './AppliancesFinish';
import {
    AppliancesFinishFromJSON,
    AppliancesFinishFromJSONTyped,
    AppliancesFinishToJSON,
} from './AppliancesFinish';
import type { AppliancesNeedReplacement } from './AppliancesNeedReplacement';
import {
    AppliancesNeedReplacementFromJSON,
    AppliancesNeedReplacementFromJSONTyped,
    AppliancesNeedReplacementToJSON,
} from './AppliancesNeedReplacement';
import type { AsIsListPrice } from './AsIsListPrice';
import {
    AsIsListPriceFromJSON,
    AsIsListPriceFromJSONTyped,
    AsIsListPriceToJSON,
} from './AsIsListPrice';
import type { AttachedGarageFunctional } from './AttachedGarageFunctional';
import {
    AttachedGarageFunctionalFromJSON,
    AttachedGarageFunctionalFromJSONTyped,
    AttachedGarageFunctionalToJSON,
} from './AttachedGarageFunctional';
import type { AtticCrawlSpaceAccessible } from './AtticCrawlSpaceAccessible';
import {
    AtticCrawlSpaceAccessibleFromJSON,
    AtticCrawlSpaceAccessibleFromJSONTyped,
    AtticCrawlSpaceAccessibleToJSON,
} from './AtticCrawlSpaceAccessible';
import type { AverageNeighborhoodDom } from './AverageNeighborhoodDom';
import {
    AverageNeighborhoodDomFromJSON,
    AverageNeighborhoodDomFromJSONTyped,
    AverageNeighborhoodDomToJSON,
} from './AverageNeighborhoodDom';
import type { CloseToBusyRoad } from './CloseToBusyRoad';
import {
    CloseToBusyRoadFromJSON,
    CloseToBusyRoadFromJSONTyped,
    CloseToBusyRoadToJSON,
} from './CloseToBusyRoad';
import type { CloseToHighVoltageLines } from './CloseToHighVoltageLines';
import {
    CloseToHighVoltageLinesFromJSON,
    CloseToHighVoltageLinesFromJSONTyped,
    CloseToHighVoltageLinesToJSON,
} from './CloseToHighVoltageLines';
import type { Comp1Address } from './Comp1Address';
import {
    Comp1AddressFromJSON,
    Comp1AddressFromJSONTyped,
    Comp1AddressToJSON,
} from './Comp1Address';
import type { Comp1Condition } from './Comp1Condition';
import {
    Comp1ConditionFromJSON,
    Comp1ConditionFromJSONTyped,
    Comp1ConditionToJSON,
} from './Comp1Condition';
import type { Comp1MlsId } from './Comp1MlsId';
import {
    Comp1MlsIdFromJSON,
    Comp1MlsIdFromJSONTyped,
    Comp1MlsIdToJSON,
} from './Comp1MlsId';
import type { Comp2Address } from './Comp2Address';
import {
    Comp2AddressFromJSON,
    Comp2AddressFromJSONTyped,
    Comp2AddressToJSON,
} from './Comp2Address';
import type { Comp2Condition } from './Comp2Condition';
import {
    Comp2ConditionFromJSON,
    Comp2ConditionFromJSONTyped,
    Comp2ConditionToJSON,
} from './Comp2Condition';
import type { Comp2MlsId } from './Comp2MlsId';
import {
    Comp2MlsIdFromJSON,
    Comp2MlsIdFromJSONTyped,
    Comp2MlsIdToJSON,
} from './Comp2MlsId';
import type { Comp3Address } from './Comp3Address';
import {
    Comp3AddressFromJSON,
    Comp3AddressFromJSONTyped,
    Comp3AddressToJSON,
} from './Comp3Address';
import type { Comp3Condition } from './Comp3Condition';
import {
    Comp3ConditionFromJSON,
    Comp3ConditionFromJSONTyped,
    Comp3ConditionToJSON,
} from './Comp3Condition';
import type { Comp3MlsId } from './Comp3MlsId';
import {
    Comp3MlsIdFromJSON,
    Comp3MlsIdFromJSONTyped,
    Comp3MlsIdToJSON,
} from './Comp3MlsId';
import type { Comp4Address } from './Comp4Address';
import {
    Comp4AddressFromJSON,
    Comp4AddressFromJSONTyped,
    Comp4AddressToJSON,
} from './Comp4Address';
import type { Comp4Condition } from './Comp4Condition';
import {
    Comp4ConditionFromJSON,
    Comp4ConditionFromJSONTyped,
    Comp4ConditionToJSON,
} from './Comp4Condition';
import type { Comp4MlsId } from './Comp4MlsId';
import {
    Comp4MlsIdFromJSON,
    Comp4MlsIdFromJSONTyped,
    Comp4MlsIdToJSON,
} from './Comp4MlsId';
import type { DryrotInsectsDescription } from './DryrotInsectsDescription';
import {
    DryrotInsectsDescriptionFromJSON,
    DryrotInsectsDescriptionFromJSONTyped,
    DryrotInsectsDescriptionToJSON,
} from './DryrotInsectsDescription';
import type { ElectricityOnFunctional } from './ElectricityOnFunctional';
import {
    ElectricityOnFunctionalFromJSON,
    ElectricityOnFunctionalFromJSONTyped,
    ElectricityOnFunctionalToJSON,
} from './ElectricityOnFunctional';
import type { ExteriorCondition } from './ExteriorCondition';
import {
    ExteriorConditionFromJSON,
    ExteriorConditionFromJSONTyped,
    ExteriorConditionToJSON,
} from './ExteriorCondition';
import type { GasOnFunctional } from './GasOnFunctional';
import {
    GasOnFunctionalFromJSON,
    GasOnFunctionalFromJSONTyped,
    GasOnFunctionalToJSON,
} from './GasOnFunctional';
import type { InstalledAppliances } from './InstalledAppliances';
import {
    InstalledAppliancesFromJSON,
    InstalledAppliancesFromJSONTyped,
    InstalledAppliancesToJSON,
} from './InstalledAppliances';
import type { InteriorCondition } from './InteriorCondition';
import {
    InteriorConditionFromJSON,
    InteriorConditionFromJSONTyped,
    InteriorConditionToJSON,
} from './InteriorCondition';
import type { KitchenCounterFinish } from './KitchenCounterFinish';
import {
    KitchenCounterFinishFromJSON,
    KitchenCounterFinishFromJSONTyped,
    KitchenCounterFinishToJSON,
} from './KitchenCounterFinish';
import type { ListingId } from './ListingId';
import {
    ListingIdFromJSON,
    ListingIdFromJSONTyped,
    ListingIdToJSON,
} from './ListingId';
import type { LockboxLocation } from './LockboxLocation';
import {
    LockboxLocationFromJSON,
    LockboxLocationFromJSONTyped,
    LockboxLocationToJSON,
} from './LockboxLocation';
import type { Lss } from './Lss';
import {
    LssFromJSON,
    LssFromJSONTyped,
    LssToJSON,
} from './Lss';
import type { MailOrNotices } from './MailOrNotices';
import {
    MailOrNoticesFromJSON,
    MailOrNoticesFromJSONTyped,
    MailOrNoticesToJSON,
} from './MailOrNotices';
import type { NeighborhoodSupplyMonths } from './NeighborhoodSupplyMonths';
import {
    NeighborhoodSupplyMonthsFromJSON,
    NeighborhoodSupplyMonthsFromJSONTyped,
    NeighborhoodSupplyMonthsToJSON,
} from './NeighborhoodSupplyMonths';
import type { NewBuildCommunities } from './NewBuildCommunities';
import {
    NewBuildCommunitiesFromJSON,
    NewBuildCommunitiesFromJSONTyped,
    NewBuildCommunitiesToJSON,
} from './NewBuildCommunities';
import type { NoneFunctionalKeys } from './NoneFunctionalKeys';
import {
    NoneFunctionalKeysFromJSON,
    NoneFunctionalKeysFromJSONTyped,
    NoneFunctionalKeysToJSON,
} from './NoneFunctionalKeys';
import type { NumberOfFunctionalFrontEntryKeys } from './NumberOfFunctionalFrontEntryKeys';
import {
    NumberOfFunctionalFrontEntryKeysFromJSON,
    NumberOfFunctionalFrontEntryKeysFromJSONTyped,
    NumberOfFunctionalFrontEntryKeysToJSON,
} from './NumberOfFunctionalFrontEntryKeys';
import type { ObviousDamage } from './ObviousDamage';
import {
    ObviousDamageFromJSON,
    ObviousDamageFromJSONTyped,
    ObviousDamageToJSON,
} from './ObviousDamage';
import type { OdorsPresent } from './OdorsPresent';
import {
    OdorsPresentFromJSON,
    OdorsPresentFromJSONTyped,
    OdorsPresentToJSON,
} from './OdorsPresent';
import type { OtherIssues } from './OtherIssues';
import {
    OtherIssuesFromJSON,
    OtherIssuesFromJSONTyped,
    OtherIssuesToJSON,
} from './OtherIssues';
import type { OutputSheet } from './OutputSheet';
import {
    OutputSheetFromJSON,
    OutputSheetFromJSONTyped,
    OutputSheetToJSON,
} from './OutputSheet';
import type { PhotosUrl } from './PhotosUrl';
import {
    PhotosUrlFromJSON,
    PhotosUrlFromJSONTyped,
    PhotosUrlToJSON,
} from './PhotosUrl';
import type { PrimaryFlooringType } from './PrimaryFlooringType';
import {
    PrimaryFlooringTypeFromJSON,
    PrimaryFlooringTypeFromJSONTyped,
    PrimaryFlooringTypeToJSON,
} from './PrimaryFlooringType';
import type { PropertyAddress } from './PropertyAddress';
import {
    PropertyAddressFromJSON,
    PropertyAddressFromJSONTyped,
    PropertyAddressToJSON,
} from './PropertyAddress';
import type { PropertyComments } from './PropertyComments';
import {
    PropertyCommentsFromJSON,
    PropertyCommentsFromJSONTyped,
    PropertyCommentsToJSON,
} from './PropertyComments';
import type { PropertySloped } from './PropertySloped';
import {
    PropertySlopedFromJSON,
    PropertySlopedFromJSONTyped,
    PropertySlopedToJSON,
} from './PropertySloped';
import type { RecommendedListPrice } from './RecommendedListPrice';
import {
    RecommendedListPriceFromJSON,
    RecommendedListPriceFromJSONTyped,
    RecommendedListPriceToJSON,
} from './RecommendedListPrice';
import type { RoofDamageDescription } from './RoofDamageDescription';
import {
    RoofDamageDescriptionFromJSON,
    RoofDamageDescriptionFromJSONTyped,
    RoofDamageDescriptionToJSON,
} from './RoofDamageDescription';
import type { RowId } from './RowId';
import {
    RowIdFromJSON,
    RowIdFromJSONTyped,
    RowIdToJSON,
} from './RowId';
import type { RowNumber } from './RowNumber';
import {
    RowNumberFromJSON,
    RowNumberFromJSONTyped,
    RowNumberToJSON,
} from './RowNumber';
import type { SecondaryFlooringType } from './SecondaryFlooringType';
import {
    SecondaryFlooringTypeFromJSON,
    SecondaryFlooringTypeFromJSONTyped,
    SecondaryFlooringTypeToJSON,
} from './SecondaryFlooringType';
import type { SlackId } from './SlackId';
import {
    SlackIdFromJSON,
    SlackIdFromJSONTyped,
    SlackIdToJSON,
} from './SlackId';
import type { SprinkleSystem } from './SprinkleSystem';
import {
    SprinkleSystemFromJSON,
    SprinkleSystemFromJSONTyped,
    SprinkleSystemToJSON,
} from './SprinkleSystem';
import type { Squatters } from './Squatters';
import {
    SquattersFromJSON,
    SquattersFromJSONTyped,
    SquattersToJSON,
} from './Squatters';
import type { SquattersDescription } from './SquattersDescription';
import {
    SquattersDescriptionFromJSON,
    SquattersDescriptionFromJSONTyped,
    SquattersDescriptionToJSON,
} from './SquattersDescription';
import type { StreetAccessRestrictions } from './StreetAccessRestrictions';
import {
    StreetAccessRestrictionsFromJSON,
    StreetAccessRestrictionsFromJSONTyped,
    StreetAccessRestrictionsToJSON,
} from './StreetAccessRestrictions';
import type { UtilitiesFunctional } from './UtilitiesFunctional';
import {
    UtilitiesFunctionalFromJSON,
    UtilitiesFunctionalFromJSONTyped,
    UtilitiesFunctionalToJSON,
} from './UtilitiesFunctional';
import type { UtilityDetails } from './UtilityDetails';
import {
    UtilityDetailsFromJSON,
    UtilityDetailsFromJSONTyped,
    UtilityDetailsToJSON,
} from './UtilityDetails';
import type { VideoNotes } from './VideoNotes';
import {
    VideoNotesFromJSON,
    VideoNotesFromJSONTyped,
    VideoNotesToJSON,
} from './VideoNotes';
import type { VideoUrl } from './VideoUrl';
import {
    VideoUrlFromJSON,
    VideoUrlFromJSONTyped,
    VideoUrlToJSON,
} from './VideoUrl';
import type { VisibleHomeDamage } from './VisibleHomeDamage';
import {
    VisibleHomeDamageFromJSON,
    VisibleHomeDamageFromJSONTyped,
    VisibleHomeDamageToJSON,
} from './VisibleHomeDamage';
import type { VisibleRoofDamage } from './VisibleRoofDamage';
import {
    VisibleRoofDamageFromJSON,
    VisibleRoofDamageFromJSONTyped,
    VisibleRoofDamageToJSON,
} from './VisibleRoofDamage';
import type { VisitFormId } from './VisitFormId';
import {
    VisitFormIdFromJSON,
    VisitFormIdFromJSONTyped,
    VisitFormIdToJSON,
} from './VisitFormId';
import type { VisitFormType } from './VisitFormType';
import {
    VisitFormTypeFromJSON,
    VisitFormTypeFromJSONTyped,
    VisitFormTypeToJSON,
} from './VisitFormType';
import type { WaterFunctioning } from './WaterFunctioning';
import {
    WaterFunctioningFromJSON,
    WaterFunctioningFromJSONTyped,
    WaterFunctioningToJSON,
} from './WaterFunctioning';
import type { WaterLeak } from './WaterLeak';
import {
    WaterLeakFromJSON,
    WaterLeakFromJSONTyped,
    WaterLeakToJSON,
} from './WaterLeak';
import type { WaterLeakDescription } from './WaterLeakDescription';
import {
    WaterLeakDescriptionFromJSON,
    WaterLeakDescriptionFromJSONTyped,
    WaterLeakDescriptionToJSON,
} from './WaterLeakDescription';
import type { WaterOnFunctional } from './WaterOnFunctional';
import {
    WaterOnFunctionalFromJSON,
    WaterOnFunctionalFromJSONTyped,
    WaterOnFunctionalToJSON,
} from './WaterOnFunctional';
import type { WaterSuppliesFunctional } from './WaterSuppliesFunctional';
import {
    WaterSuppliesFunctionalFromJSON,
    WaterSuppliesFunctionalFromJSONTyped,
    WaterSuppliesFunctionalToJSON,
} from './WaterSuppliesFunctional';
import type { WereAbleToAccessProperty } from './WereAbleToAccessProperty';
import {
    WereAbleToAccessPropertyFromJSON,
    WereAbleToAccessPropertyFromJSONTyped,
    WereAbleToAccessPropertyToJSON,
} from './WereAbleToAccessProperty';
import type { WorkingCodes } from './WorkingCodes';
import {
    WorkingCodesFromJSON,
    WorkingCodesFromJSONTyped,
    WorkingCodesToJSON,
} from './WorkingCodes';
import type { WouldLikeToProvidePhotos } from './WouldLikeToProvidePhotos';
import {
    WouldLikeToProvidePhotosFromJSON,
    WouldLikeToProvidePhotosFromJSONTyped,
    WouldLikeToProvidePhotosToJSON,
} from './WouldLikeToProvidePhotos';

/**
 * 
 * @export
 * @interface PrewalkAgentResultsRequest
 */
export interface PrewalkAgentResultsRequest {
    /**
     * 
     * @type {PropertyAddress}
     * @memberof PrewalkAgentResultsRequest
     */
    propertyAddress?: PropertyAddress;
    /**
     * 
     * @type {WereAbleToAccessProperty}
     * @memberof PrewalkAgentResultsRequest
     */
    wereAbleToAccessProperty?: WereAbleToAccessProperty;
    /**
     * 
     * @type {NumberOfFunctionalFrontEntryKeys}
     * @memberof PrewalkAgentResultsRequest
     */
    numberOfFunctionalFrontEntryKeys?: NumberOfFunctionalFrontEntryKeys;
    /**
     * 
     * @type {WorkingCodes}
     * @memberof PrewalkAgentResultsRequest
     */
    workingCodes?: WorkingCodes;
    /**
     * 
     * @type {AccessIssues}
     * @memberof PrewalkAgentResultsRequest
     */
    accessIssues?: AccessIssues;
    /**
     * 
     * @type {NoneFunctionalKeys}
     * @memberof PrewalkAgentResultsRequest
     */
    noneFunctionalKeys?: NoneFunctionalKeys;
    /**
     * 
     * @type {SprinkleSystem}
     * @memberof PrewalkAgentResultsRequest
     */
    sprinkleSystem?: SprinkleSystem;
    /**
     * 
     * @type {PropertyComments}
     * @memberof PrewalkAgentResultsRequest
     */
    propertyComments?: PropertyComments;
    /**
     * 
     * @type {WouldLikeToProvidePhotos}
     * @memberof PrewalkAgentResultsRequest
     */
    wouldLikeToProvidePhotos?: WouldLikeToProvidePhotos;
    /**
     * 
     * @type {VisibleRoofDamage}
     * @memberof PrewalkAgentResultsRequest
     */
    visibleRoofDamage?: VisibleRoofDamage;
    /**
     * 
     * @type {InstalledAppliances}
     * @memberof PrewalkAgentResultsRequest
     */
    installedAppliances?: InstalledAppliances;
    /**
     * 
     * @type {AllUtilitiesFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    allUtilitiesFunctional?: AllUtilitiesFunctional;
    /**
     * 
     * @type {LockboxLocation}
     * @memberof PrewalkAgentResultsRequest
     */
    lockboxLocation?: LockboxLocation;
    /**
     * 
     * @type {AppliancesNeedReplacement}
     * @memberof PrewalkAgentResultsRequest
     */
    appliancesNeedReplacement?: AppliancesNeedReplacement;
    /**
     * 
     * @type {OdorsPresent}
     * @memberof PrewalkAgentResultsRequest
     */
    odorsPresent?: OdorsPresent;
    /**
     * 
     * @type {RowId}
     * @memberof PrewalkAgentResultsRequest
     */
    rowId?: RowId;
    /**
     * 
     * @type {KitchenCounterFinish}
     * @memberof PrewalkAgentResultsRequest
     */
    kitchenCounterFinish?: KitchenCounterFinish;
    /**
     * 
     * @type {ExteriorCondition}
     * @memberof PrewalkAgentResultsRequest
     */
    exteriorCondition?: ExteriorCondition;
    /**
     * 
     * @type {VisibleHomeDamage}
     * @memberof PrewalkAgentResultsRequest
     */
    visibleHomeDamage?: VisibleHomeDamage;
    /**
     * 
     * @type {WaterSuppliesFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    waterSuppliesFunctional?: WaterSuppliesFunctional;
    /**
     * 
     * @type {AverageNeighborhoodDom}
     * @memberof PrewalkAgentResultsRequest
     */
    averageNeighborhoodDom?: AverageNeighborhoodDom;
    /**
     * 
     * @type {NeighborhoodSupplyMonths}
     * @memberof PrewalkAgentResultsRequest
     */
    neighborhoodSupplyMonths?: NeighborhoodSupplyMonths;
    /**
     * 
     * @type {RecommendedListPrice}
     * @memberof PrewalkAgentResultsRequest
     */
    recommendedListPrice?: RecommendedListPrice;
    /**
     * 
     * @type {AsIsListPrice}
     * @memberof PrewalkAgentResultsRequest
     */
    asIsListPrice?: AsIsListPrice;
    /**
     * 
     * @type {AtticCrawlSpaceAccessible}
     * @memberof PrewalkAgentResultsRequest
     */
    atticCrawlSpaceAccessible?: AtticCrawlSpaceAccessible;
    /**
     * 
     * @type {AnyHomeDamage}
     * @memberof PrewalkAgentResultsRequest
     */
    anyHomeDamage?: AnyHomeDamage;
    /**
     * 
     * @type {CloseToHighVoltageLines}
     * @memberof PrewalkAgentResultsRequest
     */
    closeToHighVoltageLines?: CloseToHighVoltageLines;
    /**
     * 
     * @type {AgentJustification}
     * @memberof PrewalkAgentResultsRequest
     */
    agentJustification?: AgentJustification;
    /**
     * 
     * @type {StreetAccessRestrictions}
     * @memberof PrewalkAgentResultsRequest
     */
    streetAccessRestrictions?: StreetAccessRestrictions;
    /**
     * 
     * @type {PrimaryFlooringType}
     * @memberof PrewalkAgentResultsRequest
     */
    primaryFlooringType?: PrimaryFlooringType;
    /**
     * 
     * @type {OtherIssues}
     * @memberof PrewalkAgentResultsRequest
     */
    otherIssues?: OtherIssues;
    /**
     * 
     * @type {Comp1MlsId}
     * @memberof PrewalkAgentResultsRequest
     */
    comp1MlsId?: Comp1MlsId;
    /**
     * 
     * @type {Comp2Address}
     * @memberof PrewalkAgentResultsRequest
     */
    comp2Address?: Comp2Address;
    /**
     * 
     * @type {Comp2MlsId}
     * @memberof PrewalkAgentResultsRequest
     */
    comp2MlsId?: Comp2MlsId;
    /**
     * 
     * @type {Comp2Condition}
     * @memberof PrewalkAgentResultsRequest
     */
    comp2Condition?: Comp2Condition;
    /**
     * 
     * @type {Comp3Address}
     * @memberof PrewalkAgentResultsRequest
     */
    comp3Address?: Comp3Address;
    /**
     * 
     * @type {AppliancesFinish}
     * @memberof PrewalkAgentResultsRequest
     */
    appliancesFinish?: AppliancesFinish;
    /**
     * 
     * @type {SecondaryFlooringType}
     * @memberof PrewalkAgentResultsRequest
     */
    secondaryFlooringType?: SecondaryFlooringType;
    /**
     * 
     * @type {InteriorCondition}
     * @memberof PrewalkAgentResultsRequest
     */
    interiorCondition?: InteriorCondition;
    /**
     * 
     * @type {Comp1Address}
     * @memberof PrewalkAgentResultsRequest
     */
    comp1Address?: Comp1Address;
    /**
     * 
     * @type {Comp1Condition}
     * @memberof PrewalkAgentResultsRequest
     */
    comp1Condition?: Comp1Condition;
    /**
     * 
     * @type {Comp3Condition}
     * @memberof PrewalkAgentResultsRequest
     */
    comp3Condition?: Comp3Condition;
    /**
     * 
     * @type {Comp4Address}
     * @memberof PrewalkAgentResultsRequest
     */
    comp4Address?: Comp4Address;
    /**
     * 
     * @type {AttachedGarageFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    attachedGarageFunctional?: AttachedGarageFunctional;
    /**
     * 
     * @type {CloseToBusyRoad}
     * @memberof PrewalkAgentResultsRequest
     */
    closeToBusyRoad?: CloseToBusyRoad;
    /**
     * 
     * @type {PropertySloped}
     * @memberof PrewalkAgentResultsRequest
     */
    propertySloped?: PropertySloped;
    /**
     * 
     * @type {NewBuildCommunities}
     * @memberof PrewalkAgentResultsRequest
     */
    newBuildCommunities?: NewBuildCommunities;
    /**
     * 
     * @type {Comp4Condition}
     * @memberof PrewalkAgentResultsRequest
     */
    comp4Condition?: Comp4Condition;
    /**
     * 
     * @type {VideoUrl}
     * @memberof PrewalkAgentResultsRequest
     */
    videoUrl?: VideoUrl;
    /**
     * 
     * @type {RowNumber}
     * @memberof PrewalkAgentResultsRequest
     */
    rowNumber?: RowNumber;
    /**
     * 
     * @type {PhotosUrl}
     * @memberof PrewalkAgentResultsRequest
     */
    photosUrl?: PhotosUrl;
    /**
     * 
     * @type {Lss}
     * @memberof PrewalkAgentResultsRequest
     */
    lss?: Lss;
    /**
     * 
     * @type {SlackId}
     * @memberof PrewalkAgentResultsRequest
     */
    slackId?: SlackId;
    /**
     * 
     * @type {Comp4MlsId}
     * @memberof PrewalkAgentResultsRequest
     */
    comp4MlsId?: Comp4MlsId;
    /**
     * 
     * @type {Comp3MlsId}
     * @memberof PrewalkAgentResultsRequest
     */
    comp3MlsId?: Comp3MlsId;
    /**
     * 
     * @type {OutputSheet}
     * @memberof PrewalkAgentResultsRequest
     */
    outputSheet?: OutputSheet;
    /**
     * 
     * @type {UtilitiesFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    utilitiesFunctional?: UtilitiesFunctional;
    /**
     * 
     * @type {UtilityDetails}
     * @memberof PrewalkAgentResultsRequest
     */
    utilityDetails?: UtilityDetails;
    /**
     * 
     * @type {WaterFunctioning}
     * @memberof PrewalkAgentResultsRequest
     */
    waterFunctioning?: WaterFunctioning;
    /**
     * 
     * @type {RoofDamageDescription}
     * @memberof PrewalkAgentResultsRequest
     */
    roofDamageDescription?: RoofDamageDescription;
    /**
     * 
     * @type {DryrotInsectsDescription}
     * @memberof PrewalkAgentResultsRequest
     */
    dryrotInsectsDescription?: DryrotInsectsDescription;
    /**
     * 
     * @type {ObviousDamage}
     * @memberof PrewalkAgentResultsRequest
     */
    obviousDamage?: ObviousDamage;
    /**
     * 
     * @type {VideoNotes}
     * @memberof PrewalkAgentResultsRequest
     */
    videoNotes?: VideoNotes;
    /**
     * 
     * @type {Squatters}
     * @memberof PrewalkAgentResultsRequest
     */
    squatters?: Squatters;
    /**
     * 
     * @type {SquattersDescription}
     * @memberof PrewalkAgentResultsRequest
     */
    squattersDescription?: SquattersDescription;
    /**
     * 
     * @type {ElectricityOnFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    electricityOnFunctional?: ElectricityOnFunctional;
    /**
     * 
     * @type {WaterOnFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    waterOnFunctional?: WaterOnFunctional;
    /**
     * 
     * @type {GasOnFunctional}
     * @memberof PrewalkAgentResultsRequest
     */
    gasOnFunctional?: GasOnFunctional;
    /**
     * 
     * @type {WaterLeak}
     * @memberof PrewalkAgentResultsRequest
     */
    waterLeak?: WaterLeak;
    /**
     * 
     * @type {WaterLeakDescription}
     * @memberof PrewalkAgentResultsRequest
     */
    waterLeakDescription?: WaterLeakDescription;
    /**
     * 
     * @type {MailOrNotices}
     * @memberof PrewalkAgentResultsRequest
     */
    mailOrNotices?: MailOrNotices;
    /**
     * 
     * @type {VisitFormId}
     * @memberof PrewalkAgentResultsRequest
     */
    visitFormId?: VisitFormId;
    /**
     * 
     * @type {VisitFormType}
     * @memberof PrewalkAgentResultsRequest
     */
    visitType?: VisitFormType;
    /**
     * 
     * @type {ListingId}
     * @memberof PrewalkAgentResultsRequest
     */
    listingId?: ListingId;
}

/**
 * Check if a given object implements the PrewalkAgentResultsRequest interface.
 */
export function instanceOfPrewalkAgentResultsRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PrewalkAgentResultsRequestFromJSON(json: any): PrewalkAgentResultsRequest {
    return PrewalkAgentResultsRequestFromJSONTyped(json, false);
}

export function PrewalkAgentResultsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PrewalkAgentResultsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'propertyAddress': !exists(json, 'property_address') ? undefined : PropertyAddressFromJSON(json['property_address']),
        'wereAbleToAccessProperty': !exists(json, 'were_able_to_access_property') ? undefined : WereAbleToAccessPropertyFromJSON(json['were_able_to_access_property']),
        'numberOfFunctionalFrontEntryKeys': !exists(json, 'number_of_functional_front_entry_keys') ? undefined : NumberOfFunctionalFrontEntryKeysFromJSON(json['number_of_functional_front_entry_keys']),
        'workingCodes': !exists(json, 'working_codes') ? undefined : WorkingCodesFromJSON(json['working_codes']),
        'accessIssues': !exists(json, 'access_issues') ? undefined : AccessIssuesFromJSON(json['access_issues']),
        'noneFunctionalKeys': !exists(json, 'none_functional_keys') ? undefined : NoneFunctionalKeysFromJSON(json['none_functional_keys']),
        'sprinkleSystem': !exists(json, 'sprinkle_system') ? undefined : SprinkleSystemFromJSON(json['sprinkle_system']),
        'propertyComments': !exists(json, 'property_comments') ? undefined : PropertyCommentsFromJSON(json['property_comments']),
        'wouldLikeToProvidePhotos': !exists(json, 'would_like_to_provide_photos') ? undefined : WouldLikeToProvidePhotosFromJSON(json['would_like_to_provide_photos']),
        'visibleRoofDamage': !exists(json, 'visible_roof_damage') ? undefined : VisibleRoofDamageFromJSON(json['visible_roof_damage']),
        'installedAppliances': !exists(json, 'installed_appliances') ? undefined : InstalledAppliancesFromJSON(json['installed_appliances']),
        'allUtilitiesFunctional': !exists(json, 'all_utilities_functional') ? undefined : AllUtilitiesFunctionalFromJSON(json['all_utilities_functional']),
        'lockboxLocation': !exists(json, 'lockbox_location') ? undefined : LockboxLocationFromJSON(json['lockbox_location']),
        'appliancesNeedReplacement': !exists(json, 'appliances_need_replacement') ? undefined : AppliancesNeedReplacementFromJSON(json['appliances_need_replacement']),
        'odorsPresent': !exists(json, 'odors_present') ? undefined : OdorsPresentFromJSON(json['odors_present']),
        'rowId': !exists(json, 'row_id') ? undefined : RowIdFromJSON(json['row_id']),
        'kitchenCounterFinish': !exists(json, 'kitchen_counter_finish') ? undefined : KitchenCounterFinishFromJSON(json['kitchen_counter_finish']),
        'exteriorCondition': !exists(json, 'exterior_condition') ? undefined : ExteriorConditionFromJSON(json['exterior_condition']),
        'visibleHomeDamage': !exists(json, 'visible_home_damage') ? undefined : VisibleHomeDamageFromJSON(json['visible_home_damage']),
        'waterSuppliesFunctional': !exists(json, 'water_supplies_functional') ? undefined : WaterSuppliesFunctionalFromJSON(json['water_supplies_functional']),
        'averageNeighborhoodDom': !exists(json, 'average_neighborhood_dom') ? undefined : AverageNeighborhoodDomFromJSON(json['average_neighborhood_dom']),
        'neighborhoodSupplyMonths': !exists(json, 'neighborhood_supply_months') ? undefined : NeighborhoodSupplyMonthsFromJSON(json['neighborhood_supply_months']),
        'recommendedListPrice': !exists(json, 'recommended_list_price') ? undefined : RecommendedListPriceFromJSON(json['recommended_list_price']),
        'asIsListPrice': !exists(json, 'as_is_list_price') ? undefined : AsIsListPriceFromJSON(json['as_is_list_price']),
        'atticCrawlSpaceAccessible': !exists(json, 'attic_crawl_space_accessible') ? undefined : AtticCrawlSpaceAccessibleFromJSON(json['attic_crawl_space_accessible']),
        'anyHomeDamage': !exists(json, 'any_home_damage') ? undefined : AnyHomeDamageFromJSON(json['any_home_damage']),
        'closeToHighVoltageLines': !exists(json, 'close_to_high_voltage_lines') ? undefined : CloseToHighVoltageLinesFromJSON(json['close_to_high_voltage_lines']),
        'agentJustification': !exists(json, 'agent_justification') ? undefined : AgentJustificationFromJSON(json['agent_justification']),
        'streetAccessRestrictions': !exists(json, 'street_access_restrictions') ? undefined : StreetAccessRestrictionsFromJSON(json['street_access_restrictions']),
        'primaryFlooringType': !exists(json, 'primary_flooring_type') ? undefined : PrimaryFlooringTypeFromJSON(json['primary_flooring_type']),
        'otherIssues': !exists(json, 'other_issues') ? undefined : OtherIssuesFromJSON(json['other_issues']),
        'comp1MlsId': !exists(json, 'comp_1_mls_id') ? undefined : Comp1MlsIdFromJSON(json['comp_1_mls_id']),
        'comp2Address': !exists(json, 'comp_2_address') ? undefined : Comp2AddressFromJSON(json['comp_2_address']),
        'comp2MlsId': !exists(json, 'comp_2_mls_id') ? undefined : Comp2MlsIdFromJSON(json['comp_2_mls_id']),
        'comp2Condition': !exists(json, 'comp_2_condition') ? undefined : Comp2ConditionFromJSON(json['comp_2_condition']),
        'comp3Address': !exists(json, 'comp_3_address') ? undefined : Comp3AddressFromJSON(json['comp_3_address']),
        'appliancesFinish': !exists(json, 'appliances_finish') ? undefined : AppliancesFinishFromJSON(json['appliances_finish']),
        'secondaryFlooringType': !exists(json, 'secondary_flooring_type') ? undefined : SecondaryFlooringTypeFromJSON(json['secondary_flooring_type']),
        'interiorCondition': !exists(json, 'interior_condition') ? undefined : InteriorConditionFromJSON(json['interior_condition']),
        'comp1Address': !exists(json, 'comp_1_address') ? undefined : Comp1AddressFromJSON(json['comp_1_address']),
        'comp1Condition': !exists(json, 'comp_1_condition') ? undefined : Comp1ConditionFromJSON(json['comp_1_condition']),
        'comp3Condition': !exists(json, 'comp_3_condition') ? undefined : Comp3ConditionFromJSON(json['comp_3_condition']),
        'comp4Address': !exists(json, 'comp_4_address') ? undefined : Comp4AddressFromJSON(json['comp_4_address']),
        'attachedGarageFunctional': !exists(json, 'attached_garage_functional') ? undefined : AttachedGarageFunctionalFromJSON(json['attached_garage_functional']),
        'closeToBusyRoad': !exists(json, 'close_to_busy_road') ? undefined : CloseToBusyRoadFromJSON(json['close_to_busy_road']),
        'propertySloped': !exists(json, 'property_sloped') ? undefined : PropertySlopedFromJSON(json['property_sloped']),
        'newBuildCommunities': !exists(json, 'new_build_communities') ? undefined : NewBuildCommunitiesFromJSON(json['new_build_communities']),
        'comp4Condition': !exists(json, 'comp_4_condition') ? undefined : Comp4ConditionFromJSON(json['comp_4_condition']),
        'videoUrl': !exists(json, 'video_url') ? undefined : VideoUrlFromJSON(json['video_url']),
        'rowNumber': !exists(json, 'row_number') ? undefined : RowNumberFromJSON(json['row_number']),
        'photosUrl': !exists(json, 'photos_url') ? undefined : PhotosUrlFromJSON(json['photos_url']),
        'lss': !exists(json, 'lss') ? undefined : LssFromJSON(json['lss']),
        'slackId': !exists(json, 'slack_id') ? undefined : SlackIdFromJSON(json['slack_id']),
        'comp4MlsId': !exists(json, 'comp_4_mls_id') ? undefined : Comp4MlsIdFromJSON(json['comp_4_mls_id']),
        'comp3MlsId': !exists(json, 'comp_3_mls_id') ? undefined : Comp3MlsIdFromJSON(json['comp_3_mls_id']),
        'outputSheet': !exists(json, 'output_sheet') ? undefined : OutputSheetFromJSON(json['output_sheet']),
        'utilitiesFunctional': !exists(json, 'utilities_functional') ? undefined : UtilitiesFunctionalFromJSON(json['utilities_functional']),
        'utilityDetails': !exists(json, 'utility_details') ? undefined : UtilityDetailsFromJSON(json['utility_details']),
        'waterFunctioning': !exists(json, 'water_functioning') ? undefined : WaterFunctioningFromJSON(json['water_functioning']),
        'roofDamageDescription': !exists(json, 'roof_damage_description') ? undefined : RoofDamageDescriptionFromJSON(json['roof_damage_description']),
        'dryrotInsectsDescription': !exists(json, 'dryrot_insects_description') ? undefined : DryrotInsectsDescriptionFromJSON(json['dryrot_insects_description']),
        'obviousDamage': !exists(json, 'obvious_damage') ? undefined : ObviousDamageFromJSON(json['obvious_damage']),
        'videoNotes': !exists(json, 'video_notes') ? undefined : VideoNotesFromJSON(json['video_notes']),
        'squatters': !exists(json, 'squatters') ? undefined : SquattersFromJSON(json['squatters']),
        'squattersDescription': !exists(json, 'squatters_description') ? undefined : SquattersDescriptionFromJSON(json['squatters_description']),
        'electricityOnFunctional': !exists(json, 'electricity_on_functional') ? undefined : ElectricityOnFunctionalFromJSON(json['electricity_on_functional']),
        'waterOnFunctional': !exists(json, 'water_on_functional') ? undefined : WaterOnFunctionalFromJSON(json['water_on_functional']),
        'gasOnFunctional': !exists(json, 'gas_on_functional') ? undefined : GasOnFunctionalFromJSON(json['gas_on_functional']),
        'waterLeak': !exists(json, 'water_leak') ? undefined : WaterLeakFromJSON(json['water_leak']),
        'waterLeakDescription': !exists(json, 'water_leak_description') ? undefined : WaterLeakDescriptionFromJSON(json['water_leak_description']),
        'mailOrNotices': !exists(json, 'mail_or_notices') ? undefined : MailOrNoticesFromJSON(json['mail_or_notices']),
        'visitFormId': !exists(json, 'visit_form_id') ? undefined : VisitFormIdFromJSON(json['visit_form_id']),
        'visitType': !exists(json, 'visit_type') ? undefined : VisitFormTypeFromJSON(json['visit_type']),
        'listingId': !exists(json, 'listing_id') ? undefined : ListingIdFromJSON(json['listing_id']),
    };
}

export function PrewalkAgentResultsRequestToJSON(value?: PrewalkAgentResultsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'property_address': PropertyAddressToJSON(value.propertyAddress),
        'were_able_to_access_property': WereAbleToAccessPropertyToJSON(value.wereAbleToAccessProperty),
        'number_of_functional_front_entry_keys': NumberOfFunctionalFrontEntryKeysToJSON(value.numberOfFunctionalFrontEntryKeys),
        'working_codes': WorkingCodesToJSON(value.workingCodes),
        'access_issues': AccessIssuesToJSON(value.accessIssues),
        'none_functional_keys': NoneFunctionalKeysToJSON(value.noneFunctionalKeys),
        'sprinkle_system': SprinkleSystemToJSON(value.sprinkleSystem),
        'property_comments': PropertyCommentsToJSON(value.propertyComments),
        'would_like_to_provide_photos': WouldLikeToProvidePhotosToJSON(value.wouldLikeToProvidePhotos),
        'visible_roof_damage': VisibleRoofDamageToJSON(value.visibleRoofDamage),
        'installed_appliances': InstalledAppliancesToJSON(value.installedAppliances),
        'all_utilities_functional': AllUtilitiesFunctionalToJSON(value.allUtilitiesFunctional),
        'lockbox_location': LockboxLocationToJSON(value.lockboxLocation),
        'appliances_need_replacement': AppliancesNeedReplacementToJSON(value.appliancesNeedReplacement),
        'odors_present': OdorsPresentToJSON(value.odorsPresent),
        'row_id': RowIdToJSON(value.rowId),
        'kitchen_counter_finish': KitchenCounterFinishToJSON(value.kitchenCounterFinish),
        'exterior_condition': ExteriorConditionToJSON(value.exteriorCondition),
        'visible_home_damage': VisibleHomeDamageToJSON(value.visibleHomeDamage),
        'water_supplies_functional': WaterSuppliesFunctionalToJSON(value.waterSuppliesFunctional),
        'average_neighborhood_dom': AverageNeighborhoodDomToJSON(value.averageNeighborhoodDom),
        'neighborhood_supply_months': NeighborhoodSupplyMonthsToJSON(value.neighborhoodSupplyMonths),
        'recommended_list_price': RecommendedListPriceToJSON(value.recommendedListPrice),
        'as_is_list_price': AsIsListPriceToJSON(value.asIsListPrice),
        'attic_crawl_space_accessible': AtticCrawlSpaceAccessibleToJSON(value.atticCrawlSpaceAccessible),
        'any_home_damage': AnyHomeDamageToJSON(value.anyHomeDamage),
        'close_to_high_voltage_lines': CloseToHighVoltageLinesToJSON(value.closeToHighVoltageLines),
        'agent_justification': AgentJustificationToJSON(value.agentJustification),
        'street_access_restrictions': StreetAccessRestrictionsToJSON(value.streetAccessRestrictions),
        'primary_flooring_type': PrimaryFlooringTypeToJSON(value.primaryFlooringType),
        'other_issues': OtherIssuesToJSON(value.otherIssues),
        'comp_1_mls_id': Comp1MlsIdToJSON(value.comp1MlsId),
        'comp_2_address': Comp2AddressToJSON(value.comp2Address),
        'comp_2_mls_id': Comp2MlsIdToJSON(value.comp2MlsId),
        'comp_2_condition': Comp2ConditionToJSON(value.comp2Condition),
        'comp_3_address': Comp3AddressToJSON(value.comp3Address),
        'appliances_finish': AppliancesFinishToJSON(value.appliancesFinish),
        'secondary_flooring_type': SecondaryFlooringTypeToJSON(value.secondaryFlooringType),
        'interior_condition': InteriorConditionToJSON(value.interiorCondition),
        'comp_1_address': Comp1AddressToJSON(value.comp1Address),
        'comp_1_condition': Comp1ConditionToJSON(value.comp1Condition),
        'comp_3_condition': Comp3ConditionToJSON(value.comp3Condition),
        'comp_4_address': Comp4AddressToJSON(value.comp4Address),
        'attached_garage_functional': AttachedGarageFunctionalToJSON(value.attachedGarageFunctional),
        'close_to_busy_road': CloseToBusyRoadToJSON(value.closeToBusyRoad),
        'property_sloped': PropertySlopedToJSON(value.propertySloped),
        'new_build_communities': NewBuildCommunitiesToJSON(value.newBuildCommunities),
        'comp_4_condition': Comp4ConditionToJSON(value.comp4Condition),
        'video_url': VideoUrlToJSON(value.videoUrl),
        'row_number': RowNumberToJSON(value.rowNumber),
        'photos_url': PhotosUrlToJSON(value.photosUrl),
        'lss': LssToJSON(value.lss),
        'slack_id': SlackIdToJSON(value.slackId),
        'comp_4_mls_id': Comp4MlsIdToJSON(value.comp4MlsId),
        'comp_3_mls_id': Comp3MlsIdToJSON(value.comp3MlsId),
        'output_sheet': OutputSheetToJSON(value.outputSheet),
        'utilities_functional': UtilitiesFunctionalToJSON(value.utilitiesFunctional),
        'utility_details': UtilityDetailsToJSON(value.utilityDetails),
        'water_functioning': WaterFunctioningToJSON(value.waterFunctioning),
        'roof_damage_description': RoofDamageDescriptionToJSON(value.roofDamageDescription),
        'dryrot_insects_description': DryrotInsectsDescriptionToJSON(value.dryrotInsectsDescription),
        'obvious_damage': ObviousDamageToJSON(value.obviousDamage),
        'video_notes': VideoNotesToJSON(value.videoNotes),
        'squatters': SquattersToJSON(value.squatters),
        'squatters_description': SquattersDescriptionToJSON(value.squattersDescription),
        'electricity_on_functional': ElectricityOnFunctionalToJSON(value.electricityOnFunctional),
        'water_on_functional': WaterOnFunctionalToJSON(value.waterOnFunctional),
        'gas_on_functional': GasOnFunctionalToJSON(value.gasOnFunctional),
        'water_leak': WaterLeakToJSON(value.waterLeak),
        'water_leak_description': WaterLeakDescriptionToJSON(value.waterLeakDescription),
        'mail_or_notices': MailOrNoticesToJSON(value.mailOrNotices),
        'visit_form_id': VisitFormIdToJSON(value.visitFormId),
        'visit_type': VisitFormTypeToJSON(value.visitType),
        'listing_id': ListingIdToJSON(value.listingId),
    };
}

